import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryDiagnosticsFilter, isDiagnosticFilter, diagnosticsfilterId, IDiagnosticWithRelations } from "../../model";

export function setDiagnosticFilterValuesReducer(state, action: PayloadAction<IDiagnosticWithRelations[]>) {
  const diagnosticFilterExists = state.filters.some(isDiagnosticFilter);

  if (diagnosticFilterExists) {
    // Si el filtre existeix, actualitzar-lo
    state.filters = [...state.filters].map((f) => {
      if (isDiagnosticFilter(f)) {
        return { ...f, enabledValues: action.payload } as IActivityHistoryDiagnosticsFilter;
      }
      return f;
    });
  } else {
    // Si el filtre no existeix, crear-lo
    const newDiagnosticFilter: IActivityHistoryDiagnosticsFilter = {
      id: diagnosticsfilterId,
      title: "Diagnòstics",
      values: [],
      enabledValues: action.payload,
    };
    state.filters = [...state.filters, newDiagnosticFilter];
  }
}
